import { Blac, Cubit } from "blac-next";
import { tracker } from "src/state/state";

interface HashActionState {
  activeHash: string | null;
}

export default class HashActionBloc extends Cubit<HashActionState> {
  static keepAlive = true;

  constructor() {
    super({ activeHash: null });
  }

  open = (hash: string): void => {
    const normalizedHash = hash.replace(/^#/, "").toLowerCase();

    this.patch({ activeHash: normalizedHash });

    tracker.track("Hash Action Opened", {
      data: { hash: normalizedHash }
    });
  };

  close = (): void => {
    const { activeHash } = this.state;

    if (activeHash) {
      tracker.track("Hash Action Closed", {
        data: { hash: activeHash }
      });
    }

    this.patch({ activeHash: null });
  };
}

export const hashActionController = Blac.getBloc(HashActionBloc);
